import {request} from '@/utils/request'

// 通过栏目id获取内容列表
export const acticleList = params => {    
    return request({
        method: 'get',
        url: '/unit/home/list',
        params
    })    
}
// 通过内容id获取内容详情
export const contentdetail = params => {    
    return request({
        method: 'get',
        url: '/unit/home/contentdetail',
        params
    })    
}
// 获取合作组织列表
export const colist = params => {    
    return request({
        method: 'get',
        url: '/unit/home/colist',
        params
    })    
}
// 单位注册
export const userRegister = params => {    
    return request({
        method: 'post',
        url: '/unit/unit/register',
        data:params
    })    
}
// 获取单位性质列表
export const unitType = params => {    
    return request({
        method: 'get',
        url: '/public/unitType',
        params
    })    
}
// 获取行政区划列表
export const address = params => {    
    return request({
        method: 'get',
        url: '/public/address',
        params
    })    
}
// 获取行业列表
export const trade = params => {    
    return request({
        method: 'get',
        url: '/public/trade',
        params
    })    
}
// 上传文件
export const uploadFile = params => {    
    return request({
        method: 'post',
        url: '/public/storage/create',
        data:params
    })    
}
// 验证用户名是否重复
export const checkUsername = params => {    
    return request({
        method: 'post',
        url: '/unit/unit/checkUsername',
        data:params
    })    
}
// 验证单位名称是否重复
export const checkUnitname = params => {    
    return request({
        method: 'post',
        url: '/unit/unit/checkUnitname',
        data:params
    })    
}